import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class KycService {

  constructor(private http: HttpClient) { }



  sendOTPForKYC(aadharNumber, latitude, longitude) {
    let jsonBody = {
      "aadharNumber": aadharNumber,
      "latitude": latitude,
      "longitude": longitude
    }
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
        var token = localStorage.getItem('wallet-token');
    
    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
   
    return this.http.post(`${environment.baseUrl}/v1/ym/retailor/tapits/ekyc/otp`, jsonBody, { headers: headers });
  }

  verifyOTPKYC(otp) {
    let jsonBody = {
      "otp": otp
    }
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
        var token = localStorage.getItem('wallet-token');
    
    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
   
    return this.http.post(`${environment.baseUrl}/v1/ym/retailor/tapits/ekyc/optvalidation`, jsonBody, { headers: headers });
  }

  doKYC(jsonBody,latitute,longitute) {
   
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
        var token = localStorage.getItem('wallet-token');
    
    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('apikey', environment.api_key);
    return this.http.post(`${environment.baseUrl}/v1/ym/retailor/tapits/ekyc/done?latitute=${latitute}&longitute=${longitute}`, jsonBody, { headers: headers });
  }
  fino2fa(jsonBody,dsn,type){
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
        var token = localStorage.getItem('wallet-token');
    
    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('deviceSerialNumber', dsn);
    return this.http.post(`${environment.baseUrl}/v1/ym/aeps/fingpay/2fa?type=${type}`, jsonBody, { headers: headers });
 
  }
  yb2fa(jsonBody,dsn,type){
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
        var token = localStorage.getItem('wallet-token');
    
    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('deviceSerialNumber', dsn);
    return this.http.post(`${environment.baseUrl}/v1/ym/aeps/yesbank/2fa?type=${type}`, jsonBody, { headers: headers });
 
  }

  aadharpay2fa(jsonBody,dsn,type){
    // const token = (JSON.parse(localStorage.getItem('currentUser'))).data['walletToken'];
        var token = localStorage.getItem('wallet-token');
    
    let headers = new HttpHeaders();
    headers = headers.append('authToken', token);
    headers = headers.append('deviceSerialNumber', dsn);
    return this.http.post(`${environment.baseUrl}/v1/ym/aadharpay/fingpay/2fa?type=${type}`, jsonBody, { headers: headers });
  }
}
